import {
  MODULES,
  type ModuleTier,
} from "../../../../packages/game-core/src";

export interface TieredModuleTextSegment {
  text: string;
  moduleId?: string;
  tier?: ModuleTier;
}

const moduleNames = [...MODULES]
  .map((module) => ({ id: module.id, name: module.name, tier: module.tier }))
  .sort((a, b) => b.name.length - a.name.length || a.name.localeCompare(b.name, "zh-CN"));

/** Splits player-facing text without losing punctuation around skill names. */
export function tieredModuleTextSegments(
  text: string,
): TieredModuleTextSegment[] {
  const segments: TieredModuleTextSegment[] = [];
  let cursor = 0;
  while (cursor < text.length) {
    let match:
      | { index: number; id: string; name: string; tier: ModuleTier }
      | undefined;
    for (const module of moduleNames) {
      const index = text.indexOf(module.name, cursor);
      if (
        index >= 0 &&
        (!match ||
          index < match.index ||
          (index === match.index && module.name.length > match.name.length))
      ) {
        match = { index, ...module };
      }
    }
    if (!match) {
      segments.push({ text: text.slice(cursor) });
      break;
    }
    if (match.index > cursor) {
      segments.push({ text: text.slice(cursor, match.index) });
    }
    segments.push({
      text: match.name,
      moduleId: match.id,
      tier: match.tier,
    });
    cursor = match.index + match.name.length;
  }
  return segments.length > 0 ? segments : [{ text }];
}

export function renderTieredModuleText(
  target: HTMLElement,
  text: string,
): void {
  target.replaceChildren(
    ...tieredModuleTextSegments(text).map((segment) => {
      if (segment.tier === undefined) {
        return document.createTextNode(segment.text);
      }
      const span = document.createElement("span");
      span.className = "skill-tier-name";
      span.dataset.tier = String(segment.tier);
      span.dataset.moduleId = segment.moduleId;
      span.textContent = segment.text;
      return span;
    }),
  );
}
